export default __webpack_public_path__ + "static/media/selectTrainingDescriptionThumbnail.a42230a5.png";